import { RequestStatus } from '../BaseAPI'
import {
  GetSelectableCustomersResponse,
  PartyDto,
  PartySearchResult,
} from './internal-api.contracts'
import { baseAddress, InternalAPI } from './InternalAPI'

export class SearchPartyAPI extends InternalAPI {
  constructor(private partyId: string) {
    super()
    this.baseAddress += `/api/parties/${partyId}/search`
  }

  public GetPartyDetails = async (
    partyId: string,
    onRequestChange: (requestStatus: Partial<RequestStatus>) => void
  ) =>
    await this.GetAsync<PartyDto>({
      relativePath: `/${partyId}`,
      onRequestChange,
    })

  public SearchPortalParties = async (
    searchText: string,
    onRequestChange: (requestStatus: Partial<RequestStatus>) => void
  ) => {
    return await this.GetAsync<GetSelectableCustomersResponse>({
      relativePath: undefined,
      uri: `${baseAddress}/api/parties/${this.partyId}/customer-portal/party-invites/selectable-customers`,
      params: {
        s: searchText,
      },
      onRequestChange,
    })
  }

  public SearchParty = async (
    searchText: string,
    onRequestChange: (requestStatus: Partial<RequestStatus>) => void
  ) =>
    await this.GetAsync<PartySearchResult[]>({
      relativePath: '',
      onRequestChange,
      params: {
        s: searchText,
      },
    })
}
